export default [
    {
        path: '/profile',
        name: 'profile',
        component: () =>
            import(
                /* webpackChunkName: "customers" */ '@/views/profile/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Perfil', to: { name: 'profile' }, disable: true },
            ],
        },
    },
]
